import { HasGitPersistenceSettings, HasRunbooksInGit, type ProjectResource } from "@octopusdeploy/octopus-server-client";
import { useOctopusFeatureToggle } from "~/hooks/useOctopusFeatureToggle";

export function useNewRunbookRunsListPageFeatureToggle(project: ProjectResource) {
    const toggleEnabled = useOctopusFeatureToggle("new-runbook-runs-list-page", false);
    const hasGitRunbooks = HasGitPersistenceSettings(project.PersistenceSettings) && HasRunbooksInGit(project.PersistenceSettings);

    return hasGitRunbooks || toggleEnabled;
}
